// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTable_wrapper__yLKHR","item__wrapper":"KanbanTable_item__wrapper__x3vy-"};